import * as yup from 'yup'
import { validations } from '@edenia/smartgate-errors-module'

const initialValues = {
  first_name: '',
  last_name: '',
  email: '',
  user_name: '',
  password: ''
}

const schema = yup.object().shape({
  first_name: yup.string().required(validations.requiredField.code),
  last_name: yup.string().required(validations.requiredField.code),
  email: yup.string().email().required(validations.requiredField.code),
  user_name: yup.string().required(validations.requiredField.code),
  password: yup
    .string()
    .required(validations.requiredField.code)
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/,
      'passwordRequirements'
    )
})

export default {
  initialValues,
  schema
}
